export const ADD_LOADING = "ADD_LOADING";
export const ADD_TODO = "ADD_TODO";
export const TODO_FAILURE = "TODO_FAILURE";
export const TODO_SUCCESS = "TODO_SUCCESS";
export const GET_TODO = "GET_TODO";
export const GET_MONTH_TODO = "GET_MONTH_TODO";
